// eslint-disable-next-line no-shadow
export enum BookingPeriods {
  FULL_DAY = '1',
  HALF_DAY_FIRST_HALF = '2',
  HALF_DAY_SECOND_HALF = '3',
  CUSTOM_TIME_SLOT = '4',
}
